import React from "react";
import { Link } from "react-router-dom";

const RelatedPostItem = ({ blog = {} }) => {
    const { id, title, tags, createdAt, image } = blog;
    return (
        <div className="card">
            <Link to={`/blogs/${id}`}>
                <img src={image} className="card-image" alt="" />
            </Link>
            <div className="p-4">
                <Link
                    to={`/blogs/${id}`}
                    className="text-lg post-title lws-RelatedPostTitle"
                >
                    {title}
                </Link>
                <div className="mb-0 tags">
                    {/* <span>#python,</span> <span>#tech,</span>
                    <span>#git</span> */}
                    {tags?.map((tag) => (
                        <span key={tag}>#{tag}</span>
                    ))}
                </div>
                <p>{createdAt}</p>
            </div>
        </div>
    );
};

export default RelatedPostItem;
